module.exports = __webpack_public_path__ + "static/img/m-1.6b07cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/m-1.png
// module id = g47o
// module chunks = 73